module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIxOSIgdmlld0JveD0iMCAwIDMwMSAyMTkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjRUYyQjJEIiBkPSJNLjUuNDA5aDMwMHYyMTguMTgySC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik04Mi4zMTguNDA5aDU0LjU0NXYyMTguMTgySDgyLjMxOHoiLz48cGF0aCBmaWxsPSIjRkZGIiBkPSJNLjUgODIuMjI3aDMwMHY1NC41NDVILjV6Ii8+PHBhdGggZmlsbD0iIzAwMjg2OCIgZD0iTTk1Ljk1NS40MDloMjcuMjczdjIxOC4xODJIOTUuOTU1eiIvPjxwYXRoIGZpbGw9IiMwMDI4NjgiIGQ9Ik0uNSA5NS44NjNoMzAwdjI3LjI3M0guNXoiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-no.svg
// module id = 6MDy
// module chunks = 2